export function formatCompactNumber(value: number): string {
  return new Intl.NumberFormat('en', {
    notation: 'compact',
    maximumFractionDigits: value >= 1_000_000 ? 1 : 0,
  }).format(value);
}

export function formatCitizenSince(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Record pending';

  return new Intl.DateTimeFormat('en', {
    month: 'short',
    year: 'numeric',
  }).format(date);
}

export function formatUpdatedAt(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Recently';

  const differenceMinutes = Math.round((date.getTime() - Date.now()) / 60_000);
  const relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  if (Math.abs(differenceMinutes) < 60) return relative.format(differenceMinutes, 'minute');

  const differenceHours = Math.round(differenceMinutes / 60);
  if (Math.abs(differenceHours) < 24) return relative.format(differenceHours, 'hour');

  return new Intl.DateTimeFormat('en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}

export function serialForCitizen(id: string): string {
  const numeric = id.replace(/\D/g, '').slice(-6).padStart(6, '0');
  return `ECL-${numeric.slice(0, 3)}-${numeric.slice(3)}`;
}
